export default "__VITE_ASSET__uqm1zWHE__"